// src/components/order/ConfirmationModal.jsx
import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const ConfirmationModal = ({ isOpen, onClose, onConfirm, isProcessing, totalCost }) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={{
                overlay: { backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: 50 },
                content: { top: '50%', left: '50%', right: 'auto', bottom: 'auto', marginRight: '-50%', transform: 'translate(-50%, -50%)', border: 'none', background: 'white', padding: '2rem', borderRadius: '0.5rem', width: '90%', maxWidth: '400px' }
            }}
        >
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">Confirm Your Order</h2>
            <p className="text-center text-gray-600 mb-2">The following amount will be deducted from your wallet:</p>
            <p className="text-center text-3xl font-extrabold text-blue-600 mb-6">₹{totalCost.toFixed(2)}</p>
            <div className="flex justify-around">
                <button
                    onClick={onClose}
                    className="px-6 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
                >
                    Cancel
                </button>
                <button
                    onClick={onConfirm}
                    disabled={isProcessing}
                    className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 disabled:bg-green-300 disabled:cursor-wait"
                >
                    {isProcessing ? "Processing..." : "Confirm & Pay"}
                </button>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;